import { useLocation } from "react-router-dom";
import { Plan } from "./context/planContext";
import { CONSTELLATION_UTIL_MAPPING } from "../../config";
import { getCurrentPromoCode } from "../../utils/promoCodeUtils";

// TODO: add proper utility type
export const handleSignUp = (
  plan: Plan,
  zipCode: string,
  utility: any,
  navigate: Function,
  location: ReturnType<typeof useLocation>,
  primaryCta: boolean = true
) => {
  const routeBasedPromoCode = getCurrentPromoCode(location.pathname);


  if (!plan) return;

  const mappedUtilityCode = utility?.utility_code ? CONSTELLATION_UTIL_MAPPING[utility.utility_code as keyof typeof CONSTELLATION_UTIL_MAPPING] || utility.utility_code : "";

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "sign_up_start",
    electricity_plan_name: plan.plan_name || "Constellation Plan",
    electricity_plan_rate: plan.price1000,
    page_path: window.location.pathname,
    electricity_plan_term: plan.contract_term,
    provider: mappedUtilityCode,
    user_region: utility?.state_id || "TX",
    zipcode: zipCode || "",
    electricity_rate_plan_id: plan.plan_id,
    campaign_source: "",
    offer_code: routeBasedPromoCode,
    button_type: primaryCta ? "primary" : "secondary"
  });
  console.log("DataLayer", {dataLayer: window.dataLayer});
  
  // Store current path for back navigation
  sessionStorage.setItem("enrollment_referrer", location.pathname + location.search);
  
  localStorage.setItem("selectProduct", JSON.stringify(plan));
  navigate(`/v2/enrollment${location.search}`);
  // Scroll to top
  window.scrollTo({ top: 0, behavior: "smooth" });
};

export const openPdfInNewTab = async (url: string) => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const pdfBlob = new Blob([blob], { type: "application/pdf" });
    const blobUrl = URL.createObjectURL(pdfBlob);
    window.open(blobUrl, "_blank");
  } catch (error) {
    // Fallback to direct open if fetch fails
    window.open(url, "_blank");
  }
};
